import Wix from '../services/wix-sdk-polyfill';

export const closeModal = (payload) => () => {
  Wix.closeWindow(payload);
};
